<template lang="pug">
div
  interessado-sicarf(
    :interessado="cadastro.interessado",
    :cadastrante="cadastro.cadastrante",
    :observer="observer",
    :hasSocios="true"
    :hasEspolio="true"
    :socios="socios"
    :isLiberacao="true"
  )
  app-documentos(
    :maxSize='25',
    :valid-extensions="['doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png']",
    :documentos="cadastro.interessado.documentos"
    :tiposDocumentos="documentos"
    :tiposDocumentosObrigatorios="documentosObrigatorios"
    :observer="observer",
    aba="Interessado",
    :validateRule='"documentosObrigatorios"',
    :isOutraPessoa='isOutraPessoa'
  )
</template>

<script>
import { mapActions } from 'vuex'
import InteressadoSicarf from '../../../../components/cadastro/InteressadoSicarf'
import AppDocumentos from '@/screens/central/components/cadastro/AppDocumentos'

export default {
  props: ['cadastro', 'observer'],

  components: {
    InteressadoSicarf,
    AppDocumentos
  },

  data () {
    return {
      documentos: [],
      documentosObrigatorios: [],
      socios: [],
      isMA: process.env.ESTADO === 'ma'
    }
  },

  async beforeRouteLeave (to, from, next) {
    await this.setDocumentosInteressado()
    await this.observer.validate({ providerName: 'Interessado/Documentos', skipIfEmpty: false })
    next()
  },

  async activated () {
    await this.setDocumentosInteressado()
  },

  computed: {
    interessado () {
      return this.cadastro.interessado
    },

    tipoInteressado () {
      return this.cadastro.interessado.pessoa.tipo
    },

    isOutraPessoa () {
      const isOutraPessoa = this.cadastro.interessado.pessoa.tipo !== this.cadastro.cadastrante.pessoa.tipo ||
        (this.cadastro.interessado.pessoa.pessoaFisica?.cpf !== this.cadastro.cadastrante.pessoa.pessoaFisica?.cpf) ||
        (this.cadastro.interessado.pessoa.pessoaJuridica?.cpf !== this.cadastro.cadastrante.pessoa.pessoaJuridica?.cnpj)
      this.setTooltipDocumentosObrigatorios(isOutraPessoa)
      return isOutraPessoa
    },

    isCadastranteInterno () {
      return this.cadastro.cadastrante.pessoa.funcionarioIterma
    }
  },

  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento'
    }),

    // Define a lista de documentos de acordo com o tipo de pessoa selecionado
    async setDocumentosInteressado () {
      if (this.cadastro.interessado.pessoa.tipo === 'PJ' && this.cadastro.interessado.pessoa.cpfCnpj) {
        this.documentos = await this.findDocumentos('interessadoPjCancelamentoClausulaResolutiva')
        this.documentosObrigatorios = await this.findDocumentos('interessadoPjCancelamentoClausulaResolutiva')
        this.documentosObrigatorios = this.documentosObrigatorios.filter(documento => documento.tipo !== 'OUTROS_INTERESSADO')
      } else {
        const documentos = await this.findDocumentos('interessadoPfCancelamentoClausulaResolutiva')
        this.documentos = documentos
        this.documentosObrigatorios = documentos.filter(documento => ['IDENTIFICACAO_INTERESSADO', 'CPF_INTERESSADO'].includes(documento.tipo))
      }
      if (this.cadastro.interessado.pessoa.tipo === 'PJ') {
        this.documentos = await this.findDocumentos('interessadoPjCancelamentoClausulaResolutiva')
        this.documentosObrigatorios = await this.findDocumentos('interessadoPjCancelamentoClausulaResolutiva')
        this.documentosObrigatorios = this.documentosObrigatorios.filter(documento => (documento.tipo !== 'OUTROS_INTERESSADO'))
        this.documentosObrigatorios = this.documentos.filter(documento => ['IDENTIFICACAO_INTERESSADO', 'CPF_PROCURADOR', 'IDENTIFICACAO_PROCURADOR', 'CNPJ_INTERESSADO'].includes(documento.tipo))
      }
      this.ajustaDocumentosObrigatoriosCpfCnpj(this.cadastro.interessado?.documentos)
    },

    setTooltipDocumentosObrigatorios (isOutraPessoa) {
      if (isOutraPessoa && !this.isMA) {
        const contemCPFRG = this.cadastro.interessado?.documentos?.filter(documento => documento.tipoDocumento?.tipo === 'IDENTIFICACAO_PESSOAL_PROCURADOR')
        this.documentosObrigatorios = [...this.documentosObrigatorios,
          {
            id: 8,
            codigo: 'ATESTADO_OBITO_INTERESSADO_PROCURACAO_PUBLICA',
            descricao: this.cadastro.interessado.pessoa.tipo === 'PJ' ? 'Procuração Pública' : 'Atestado de Óbito (Interessado) ou Procuração Pública ',
            tipo: 'CERTIDAO_OBITO_INTERESSADO'
          }
        ]
        if (!contemCPFRG.length) {
          const documentosAdicionais = [
            {
              id: 63,
              codigo: 'CPF_PROCURADOR',
              descricao: 'CPF (Procurador)',
              tipo: 'CPF_PROCURADOR'
            },
            {
              id: 62,
              codigo: 'IDENTIFICACAO_PROCURADOR',
              descricao: 'Documento de Identificação (Procurador)',
              tipo: 'IDENTIFICACAO_PROCURADOR'
            }
          ]

          const documentosAdicionaisObrigatorios = documentosAdicionais.filter((documento) => !this.documentosObrigatorios.map(d => d.codigo).includes(documento.codigo))
          this.documentosObrigatorios = [...this.documentosObrigatorios, ...documentosAdicionaisObrigatorios]
        }
      } else {
        this.documentosObrigatorios = this.documentos.filter(documento => ['IDENTIFICACAO_INTERESSADO', 'CPF_INTERESSADO', 'CNPJ_INTERESSADO'].includes(documento.tipo))
      }
      this.ajustaDocumentosObrigatoriosCpfCnpj(this.cadastro.interessado?.documentos)
    },

    ajustaDocumentosObrigatoriosCpfCnpj (documentos) {
      if (documentos) {
        const codigosJaAnexados = []
        documentos.forEach(v => {
          if (v?.tipoDocumento?.codigo === 'DOCUMENTO_DE_IDENTIFICACAO_PESSOAL_INTERESSADO') {
            codigosJaAnexados.push('CPF_INTERESSADO')
            codigosJaAnexados.push('IDENTIFICACAO_INTERESSADO')
          } else if (v?.tipoDocumento?.codigo === 'IDENTIFICACAO_PESSOAL_PROCURADOR') {
            codigosJaAnexados.push('CPF_PROCURADOR')
            codigosJaAnexados.push('IDENTIFICACAO_PROCURADOR')
          }
          codigosJaAnexados.push(v?.tipoDocumento?.codigo)
        })
        this.documentosObrigatorios = this.documentosObrigatorios.filter(documento => (!codigosJaAnexados.includes(documento.tipo)))
      }
      this.removerDocumentosObrigatoriosProcurador()
    },

    removerDocumentosObrigatoriosProcurador () {
      if (this.isCadastranteInterno) {
        this.documentosObrigatorios = this.documentosObrigatorios.filter(documento => !['IDENTIFICACAO_PESSOAL_PROCURADOR', 'PROCURACAO_PUBLICA', 'CERTIDAO_OBITO_INTERESSADO', 'IDENTIFICACAO_PROCURADOR', 'CPF_PROCURADOR'].includes(documento.tipo))
      }
    }
  },

  watch: {
    'interessado.pessoa.tipo': {
      async handler (val) {
        if (val === 'PJ') {
          this.documentos = await this.findDocumentos('interessadoPjCancelamentoClausulaResolutiva')
          this.documentosObrigatorios = await this.findDocumentos('interessadoPjCancelamentoClausulaResolutiva')
          this.documentosObrigatorios = this.documentosObrigatorios.filter(documento => (documento.tipo !== 'OUTROS_INTERESSADO'))
          this.documentosObrigatorios = this.documentos.filter(documento => ['IDENTIFICACAO_INTERESSADO', 'CPF_PROCURADOR', 'IDENTIFICACAO_PROCURADOR', 'CNPJ_INTERESSADO'].includes(documento.tipo))
        } else {
          const documentos = await this.findDocumentos('interessadoPfCancelamentoClausulaResolutiva')
          this.documentos = documentos
          this.documentosObrigatorios = documentos.filter(documento => ['IDENTIFICACAO_INTERESSADO', 'CPF_INTERESSADO'].includes(documento.tipo))
        }
        this.removerDocumentosObrigatoriosProcurador()
        this.observer.reset()
      }
    },

    'interessado.pessoa.pessoaFisica.estadoCivil': {
      async handler (val, oldval) {
        if (oldval || (val && !oldval)) {
          await this.setDocumentosInteressado()
          this.$nextTick(async () => {
            await this.observer.validate({ providerName: 'Interessado/Documentos' })
          })
        }
      }
    },

    'interessado.conjuge.pessoaFisica.possuiCertidaoObito': {
      async handler (val, oldval) {
        if (oldval !== null && this.interessado.pessoa.tipo === 'PF') {
          await this.setDocumentosInteressado()
          this.$nextTick(async () => {
            await this.observer.validate({ providerName: 'Interessado/Documentos' })
          })
        }
      }
    },

    'cadastro.interessado.documentos': {
      async handler (val, oldval) {
        this.ajustaDocumentosObrigatoriosCpfCnpj(val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/maranhao/liberacao/components/Interessado.vue